import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SeriPortBilgisi, SeriPortDurum } from '@service/fikoyt.seri-port.service';
import { BaglantiModu } from '../kart-okuyucu.component';
import { FikoYTKokBilesenComponent } from '@service/kok-bilesen/kok-bilesen.component';

@Component({
  selector: 'hmi-okuyucu-ayarlar',
  standalone: true,
  imports: [CommonModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './okuyucu-ayarlar.component.html',
  styleUrl: './okuyucu-ayarlar.component.less',
})
export class OkuyucuAyarlarComponent extends FikoYTKokBilesenComponent {
  constructor() { super(); }

  @Input() gorunur = false;
  @Input() aktifBaglanti = false;
  @Input() baglantiModu: BaglantiModu = 'seri';

  // Seri port
  @Input() portListesi: SeriPortBilgisi[] = [];
  @Input() seciliPort: SeriPortBilgisi | null = null;
  @Input() seciliBaud = 115200;
  @Input() baudSecenekleri = [9600, 19200, 38400, 57600, 115200];
  @Input() seriDurum: SeriPortDurum = 'bagli-degil';
  @Input() seriHata = '';
  @Input() seriPortDestekleniyor = true;
  @Input() seriPortAktifPort: any = null;

  // WebSocket
  @Input() wsDurum: 'bagli-degil' | 'baglaniyor' | 'bagli' | 'hata' = 'bagli-degil';
  @Input() wsHata = '';
  wsCihazKimlik = '';

  // Monitor
  @Input() seriLog: { zaman: string; veri: string; uidBulundu: boolean; uid: string }[] = [];
  komutMetni = '';

  // Tab
  aktifTab = 0;

  // Outputs
  @Output() kapatildi = new EventEmitter<void>();
  @Output() yeniPortIste = new EventEmitter<void>();
  @Output() baudDegisti = new EventEmitter<number>();
  @Output() portSecildi = new EventEmitter<SeriPortBilgisi>();
  @Output() seriBaglan = new EventEmitter<void>();
  @Output() seriKopar = new EventEmitter<void>();
  @Output() wsBaglan = new EventEmitter<void>();
  @Output() wsKopar = new EventEmitter<void>();
  @Output() logTemizle = new EventEmitter<void>();
  @Output() komutGonderildi = new EventEmitter<string>();

  kapat() {
    this.kapatildi.emit();
  }
}
